import { api } from './api';

// Types
export interface Consultation {
  _id: string;
  userId?: string | {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  consultationTypeId: string | {
    _id: string;
    name: string;
    duration: number;
    maxDuration: number;
    price: number;
    priceDisplay: string;
    description?: string;
  };
  status: 'PENDING' | 'SCHEDULED' | 'COMPLETED' | 'CANCELLED';
  name: string;
  email: string;
  phone?: string;
  experience?: string;
  goals?: string;
  budget?: string;
  location?: string;
  timeframe?: string;
  message?: string;
  scheduledDateTime?: string;
  googleCalendarEventId?: string;
  googleMeetLink?: string;
  preferredDate?: string;
  preferredTime?: string;
  scheduledAt?: string;
  completedAt?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ConsultationStats {
  total: number;
  pending: number;
  scheduled: number;
  completed: number;
  cancelled: number;
}

export interface GetConsultationsParams {
  page?: number;
  limit?: number;
  status?: 'PENDING' | 'SCHEDULED' | 'COMPLETED' | 'CANCELLED';
  consultationTypeId?: string;
  search?: string;
}

export interface UpdateConsultationData {
  status?: 'PENDING' | 'SCHEDULED' | 'COMPLETED' | 'CANCELLED';
  notes?: string;
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
  pagination?: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

// Service functions
export const consultationService = {
  /**
   * Get all consultations with pagination and filters
   */
  getConsultations: async (params: GetConsultationsParams = {}): Promise<ApiResponse<Consultation[]>> => {
    const response = await api.post('/consultations', params);
    return response.data;
  },

  /**
   * Get a single consultation by ID
   */
  getConsultation: async (id: string): Promise<ApiResponse<Consultation>> => {
    const response = await api.get(`/consultations/${id}`);
    return response.data;
  },

  /**
   * Update a consultation
   */
  updateConsultation: async (id: string, data: UpdateConsultationData): Promise<ApiResponse<Consultation>> => {
    const response = await api.put(`/consultations/${id}`, data);
    return response.data;
  },

  /**
   * Delete a consultation
   */
  deleteConsultation: async (id: string): Promise<ApiResponse<void>> => {
    const response = await api.delete(`/consultations/${id}`);
    return response.data;
  },
};

export default consultationService;

